import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Spinner } from "react-bootstrap";
import { FaMapMarkerAlt, FaBriefcase, FaCodeBranch } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import CustomPagination from "../../utility/CustomPagination";
import { Modal } from "react-bootstrap";
import { FiUser, FiMail, FiPhone } from "react-icons/fi";
import { GrAttachment } from "react-icons/gr";
import axios from "axios";
import { toast } from "react-toastify";
const jobList = [
  {
    title: "React Developer",
    location: "Bangalore, India",
    type: "Full-Time",
    description:
      "Build responsive web apps using React, Redux, and modern JavaScript stacks.",
  },
  {
    title: "Django Backend Engineer",
    location: "Remote",
    type: "Full-Time",
    description:
      "Develop RESTful APIs and scalable backend systems using Django and PostgreSQL.",
  },
  {
    title: "React Native Developer",
    location: "Hyderabad, India",
    type: "Contract",
    description:
      "Design and build cross-platform mobile applications using React Native.",
  },
  {
    title: "Full Stack Engineer",
    location: "Chennai, India",
    type: "Full-Time",
    description:
      "Work on both frontend and backend, integrating APIs and managing deployments.",
  },
  {
    title: "DevOps Engineer",
    location: "Remote",
    type: "Full-Time",
    description: "Manage CI/CD pipelines and cloud infrastructure (AWS/Azure).",
  },
  {
    title: "UI/UX Designer",
    location: "Pune, India",
    type: "Part-Time",
    description:
      "Create user-centered designs and collaborate with frontend engineers.",
  },
  {
    title: "QA Automation Engineer",
    location: "Noida, India",
    type: "Full-Time",
    description:
      "Develop automated test scripts and perform quality assurance.",
  },
  {
    title: "Technical Project Manager",
    location: "Mumbai, India",
    type: "Full-Time",
    description: "Lead agile teams and manage client delivery timelines.",
  },
  {
    title: "Cloud Architect",
    location: "Remote",
    type: "Full-Time",
    description: "Design scalable cloud solutions using AWS, Azure, or GCP.",
  },
  {
    title: "Product Owner",
    location: "Gurgaon, India",
    type: "Full-Time",
    description:
      "Own the product roadmap, requirements, and work closely with engineering.",
  },
];
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/;
const Career = () => {
  const [applyModal, setApplyModal] = useState(false);
  const [applyLoading, setApplyLoading] = useState(false);
  const [applicationForm, setApplicationForm] = useState({
    name: "",
    email: "",
    mobile: "",
    designation: "",
    resume: null,
  });
  const [errorApplicationForm, setErrorApplicationForm] = useState({
    name: "",
    email: "",
    mobile: "",
    designation: "",
    resume: "",
  });
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All type");
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 5;

  const filteredJobs = jobList.filter(
    (job) =>
      job.title.toLowerCase().includes(search.toLowerCase()) &&
      (typeFilter === "All type" || job.type === typeFilter)
  );

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
  const displayedJobs = filteredJobs.slice(
    (currentPage - 1) * jobsPerPage,
    currentPage * jobsPerPage
  );
  const handleResetApplicationForm = () => {
    setApplicationForm({
      name: "",
      email: "",
      mobile: "",
      designation: "",
      resume: null,
    });
    setErrorApplicationForm({
      name: "",
      email: "",
      mobile: "",
      designation: "",
      resume: "",
    });
  };
  const handleApplyModal = () => {
    if (applyModal) {
      handleResetApplicationForm();
    }
    setApplyModal(!applyModal);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setApplicationForm({ ...applicationForm, [name]: value });

    let error = "";

    if (name === "email") {
      if (!emailRegex.test(value)) {
        error = "Invalid email address";
      }
    }

    if (name === "mobile") {
      if (!mobileRegex.test(value)) {
        error = "Invalid mobile number";
      }
    }

    if (value && !error) {
      setErrorApplicationForm({ ...errorApplicationForm, [name]: "" });
    } else if (value) {
      setErrorApplicationForm({ ...errorApplicationForm, [name]: error });
    } else {
      setErrorApplicationForm({ ...errorApplicationForm, [name]: "" });
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!applicationForm.name.trim()) {
      newErrors.name = "First name is required";
    }

    if (!applicationForm.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(applicationForm.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!applicationForm.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(applicationForm.mobile)) {
      newErrors.mobile = "Invalid mobile number";
    }

    if (!applicationForm.designation.trim()) {
      newErrors.designation = "Designation is required";
    }

    if (!applicationForm.resume) {
      newErrors.resume = "Upload your CV";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorApplicationForm({ ...errorApplicationForm, ...newErrors });
      return;
    }
    const formData = new FormData();
    formData.append("name", applicationForm.name);
    formData.append("email", applicationForm.email);
    formData.append("mobile", applicationForm.mobile);
    formData.append("designation", applicationForm.designation);
    formData.append("resume", applicationForm.resume);

    setApplyLoading(true);
    axios
      .post(process.env.REACT_APP_API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        toast.success("Application submitted successfully");
        handleResetApplicationForm();
        setApplyModal(false);
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again.");
      })
      .finally(() => {
        setApplyLoading(false);
      });
  };
  return (
    <>
      <div className="career-hero-section text-orange text-center mb-2">
        <Container>
          <h1 className="fw-bold mb-3" data-aos="fade-up" data-aos-delay="100">
            Build Your Future at Intelisparkz
          </h1>
          <p className="lead mb-4" data-aos="fade-up" data-aos-delay="200">
            Explore roles that help shape industries and innovate the future.
          </p>

        </Container>
      </div>

      <Container className="job-section py-5">
        <div className="bg-light rounded p-4 shadow-sm mb-4 d-flex gap-3">
          <div className="position-relative" style={{ maxWidth: 280 }}>
            {/* Search Icon */}
            <FiSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-primary" />
            {/* Input */}
            <input
              type="search"
              name="search"
              className="form-control form-control-sm rounded-2 shadow-sm ps-5 pe-4 py-2"
              placeholder="Search job title..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <Dropdown>
            <Dropdown.Toggle variant="outline-primary" id="job-type-dropdown">
              {typeFilter}
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown-menu">
              {["All type", "Full-Time", "Part-Time", "Contract"].map(
                (type) => (
                  <Dropdown.Item
                    key={type}
                    onClick={() => setTypeFilter(type)}
                    active={typeFilter === type}
                    className="custom-dropdown-item"
                  >
                    {type}
                  </Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <Row className="gy-4">
          {displayedJobs.map((job, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="h-100 shadow-sm job-card border rounded-3">
                <Card.Body>
                  <Card.Title className="fw-bold text-orange">
                    {job.title}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted small d-flex align-items-center gap-2">
                    <FaBriefcase /> {job.type}
                  </Card.Subtitle>
                  <Card.Subtitle className="mb-2 text-muted small d-flex align-items-center gap-2">
                    <FaMapMarkerAlt /> {job.location}
                  </Card.Subtitle>
                  <Card.Text className="small text-muted">
                    {job.description.length > 150
                      ? job.description.slice(0, 140) + "..."
                      : job.description}
                  </Card.Text>
                  <div className="text-end">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="rounded-pill px-3"
                      onClick={handleApplyModal}
                    >
                      Apply Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {totalPages > 1 && (
          <CustomPagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </Container>
      <Modal show={applyModal} onHide={handleApplyModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Fill Correct Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 p-2">
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">
                Full Name
              </label>
              <div
                className={`input-group standard-input ${
                  errorApplicationForm?.name ? "invalid" : ""
                }`}
              >
                <span className="input-group-text bg-transparent border-0">
                  <FiUser className="text-orange" />
                </span>
                <input
                  type="text"
                  className={`form-control ${
                    errorApplicationForm?.name ? "is-invalid" : ""
                  }`}
                  id="fullName"
                  name="name"
                  placeholder="John Doe"
                  onChange={handleInputChange}
                />
              </div>
              {errorApplicationForm?.name && (
                <span className="text-danger small">
                  {errorApplicationForm?.name}
                </span>
              )}
            </div>
            <div className="d-flex gap-2">
              <div className="mb-3 flex-fill">
                <label htmlFor="email" className="form-label">
                  Email Address
                </label>
                <div
                  className={`input-group standard-input ${
                    errorApplicationForm?.email ? "invalid" : ""
                  }`}
                >
                  <span className="input-group-text bg-transparent border-0">
                    <FiMail className="text-orange" />
                  </span>
                  <input
                    type="email"
                    className={`form-control ${
                      errorApplicationForm?.email ? "is-invalid" : ""
                    }`}
                    id="email"
                    name="email"
                    placeholder="john@gmail.com"
                    onChange={handleInputChange}
                  />
                </div>
                {errorApplicationForm?.email && (
                  <span className="text-danger small">
                    {errorApplicationForm?.email}
                  </span>
                )}
              </div>

              <div className="mb-3 flex-fill">
                <label htmlFor="mobile" className="form-label">
                  Mobile Number
                </label>
                <div
                  className={`input-group standard-input ${
                    errorApplicationForm?.mobile ? "invalid" : ""
                  }`}
                >
                  <span className="input-group-text bg-transparent border-0">
                    <FiPhone className="text-orange" />
                  </span>
                  <input
                    type="text"
                    className={`form-control ${
                      errorApplicationForm?.mobile ? "is-invalid" : ""
                    }`}
                    id="mobile"
                    name="mobile"
                    placeholder="9766728632"
                    onChange={handleInputChange}
                  />
                </div>
                {errorApplicationForm?.mobile && (
                  <span className="text-danger small">
                    {errorApplicationForm?.mobile}
                  </span>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="designation" className="form-label">
                Position
              </label>
              <div
                className={`input-group standard-input ${
                  errorApplicationForm?.designation ? "invalid" : ""
                }`}
              >
                <span className="input-group-text bg-transparent border-0">
                  <FaCodeBranch className="text-orange" />
                </span>
                <input
                  type="text"
                  className={`form-control ${
                    errorApplicationForm?.designation ? "is-invalid" : ""
                  }`}
                  id="designation"
                  name="designation"
                  placeholder="Fullstack Devloper"
                  onChange={handleInputChange}
                />
              </div>
              {errorApplicationForm?.designation && (
                <span className="text-danger small">
                  {errorApplicationForm?.designation}
                </span>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Upload CV</label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control d-none"
                  id="cvUpload"
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      if (file.type !== "application/pdf") {
                        setErrorApplicationForm({
                          ...errorApplicationForm,
                          resume: "Only PDF files are allowed",
                        });
                        setApplicationForm({
                          ...applicationForm,
                          resume: null,
                        });
                        return;
                      }

                      setApplicationForm({
                        ...applicationForm,
                        resume: file,
                      });

                      setErrorApplicationForm({
                        ...errorApplicationForm,
                        resume: "",
                      });
                    }
                  }}
                />
                <label
                  htmlFor="cvUpload"
                  className="btn-sm btn rounded-2 btn-info"
                >
                  <GrAttachment className="me-1" /> Upload CV
                </label>
                <span className="ms-2 align-self-center text-muted">
                  {applicationForm?.resume?.name || "No file selected"}
                </span>
              </div>
              {errorApplicationForm?.resume && (
                <span className="text-danger small">
                  {errorApplicationForm?.resume}
                </span>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-outline-danger" onClick={handleApplyModal}>
            Close
          </button>
          <Button variant="primary" onClick={handleSubmit} disabled={applyLoading}>
            {applyLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Submit Application
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Career;
